import React, { useState, useEffect } from 'react';

export default function BigClock() {
  const [time, setTime] = useState(new Date());
  useEffect(() => {
    const iv = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(iv);
  }, []);

  const hours = time.getHours().toString().padStart(2, '0');
  const mins = time.getMinutes().toString().padStart(2, '0');
  const secs = time.getSeconds().toString().padStart(2, '0');
  const dateStr = time.toLocaleDateString('en-IN', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });

  return (
    <div className="glass-card p-8 text-center" data-testid="live-clock">
      <div className="font-heading text-6xl md:text-7xl font-black tracking-tighter text-white">
        {hours}<span className="text-indigo-500 animate-pulse">:</span>{mins}<span className="text-indigo-500 animate-pulse">:</span><span className="text-slate-400">{secs}</span>
      </div>
      <p className="text-slate-400 text-sm mt-2 tracking-wide">{dateStr}</p>
    </div>
  );
}
